class Author {
  constructor(result) {
    this.id = result.id;
    this.first_name = result.first_name;
    this.last_name = result.last_name;
    this.departments = result.departments;
    this.description = `${this.first_name} ${this.last_name}`;
  }

  get formattedDepartments() {
    const totalCount = this.departments.length;
    const selected = this.departments.slice(0, 2);
    const str = selected.join(', ');

    if (selected.length < totalCount) {
      return I18n.t('Explorer.AdvancedSearch.fields.authors.more_departments', {
        departments: str,
        count: totalCount - selected.length
      });
    } else {
      return str;
    }
  }
}

class DoiPrefix {
  constructor(result) {
    this.id = result.id;
    this.name = result.id;
    this.description = result.id;
  }
}

class FieldOfResearchCode {
  constructor(result) {
    this.id = result.id;
    this.name = result.name;
    this.description = `${result.id} ${result.name}`;
  }
}

class Country {
  constructor(result) {
    this.id = result.code;
    this.name = result.name;
    this.description = result.name;
  }
}

class MentionSource {
  constructor(result) {
    this.id = result.id;
    this.type = result.type;

    // type: post_type
    this.postType = result.post_type;

    // type: mention_source
    this.imageURL = result.image_url;
    this.profileType = result.profile_type;
    this.name = result.name;

    // type: mention_source_type
    this.mentionSourceType = result.mention_source_type;
  }

  // eslint-disable-next-line getter-return
  get description() {
    switch (this.type) {
      case 'mention_source':
        return this.name;
      case 'post_type':
        return this.postTypeDescription;
      case 'mention_source_type':
        return this.mentionSourceTypeDescription;
    }
  }

  // eslint-disable-next-line getter-return
  get title() {
    switch (this.type) {
      case 'mention_source':
        return I18n.t(this.profileType, {
          scope: 'mentions.filter.mention_source_types'
        });
      case 'post_type':
        return this.postTypeDescription;
      case 'mention_source_type':
        return this.mentionSourceTypeDescription;
    }
  }

  get postTypeDescription() {
    return I18n.t(this.postType, {
      scope: 'Explorer.Mentions.FilterPanel.autocomplete_mention_source_post_types',
      defaultValue: `Unsupported mention type '${this.postType}'`
    });
  }

  get mentionSourceTypeDescription() {
    return I18n.t(this.mentionSourceType, {
      scope: 'Explorer.MentionSources.FilterPanel.autocomplete_source_types',
      defaultValue: `Unsupported mention source type '${this.mentionSourceType}'`
    });
  }
}

class HandlePrefix {
  constructor(result) {
    this.id = result.id;
    this.description = result.id;
  }
}

class Journal {
  constructor(result) {
    this.id = result.id;
    this.title = result.title;
    this.description = result.title;
    this.issns = result.issns;
  }
}

class Grant {
  constructor(result) {
    this.id = result.id;
    this.name = result.name;
    this.description = result.name;
    this.projectName = result.project_name;
  }
}

class SustainableDevelopmentGoal {
  constructor(result) {
    this.id = result.id;
    this.name = result.name;
    this.description = `${result.id} ${result.name}`;
  }
}

class GenericResult {
  constructor(result) {
    this.id = result.id;
    this.name = result.name;
    this.description = result.name;
  }
}

export default {
  DoiPrefix,
  Author,
  Country,
  MentionSource,
  HandlePrefix,
  Journal,
  FieldOfResearchCode,
  Grant,
  SustainableDevelopmentGoal,
  GenericResult
};
